(function () {
  const productCache = Object.create(null);
  const articleRoot = document.querySelector('.article-template');
  const labels = articleRoot?.dataset || {};
  const unavailableText = labels.articleUnavailable || 'This product is currently unavailable from our store.';
  const temporaryText = labels.articleTemporarilyUnavailable || 'Product details are temporarily unavailable. Please try again later.';
  const soldOutText = labels.articleSoldOut || 'Sold out';
  const viewText = labels.articleViewProduct || 'View product';
  const viewSoldOutText = labels.articleViewSoldOut || 'View product — sold out';

  function recordUnavailable(el, handle, error) {
    el.dataset.articleReferenceState = error?.status === 404 || error?.status === 410 ? 'unresolved' : 'fetch-error';
    el.dataset.articleReferenceHandle = handle;
  }

  function unavailableMessage(error) {
    return error?.status === 404 || error?.status === 410 ? unavailableText : temporaryText;
  }

  function relatedCollectionLink() {
    const source = document.querySelector('.rcb3__btn');
    if (!source) return '';
    try {
      const url = new URL(source.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/collections/')) return '';
      return `<a href="${escHtml(url.pathname + url.search)}">${escHtml(source.textContent.trim())}</a>`;
    } catch { return ''; }
  }

  function disableUnavailableControls(handle, error) {
    document.querySelectorAll('.atc-mini[data-product]').forEach((button) => {
      if (parseHandle(button.dataset.product) !== handle) return;
      button.disabled = true;
      delete button.dataset.variantId;
      const message = document.createElement('span');
      message.className = 'article-product-unavailable';
      message.textContent = unavailableMessage(error);
      recordUnavailable(message, handle, error);
      button.replaceWith(message);
    });
    document.querySelectorAll('.tr-price[data-price-for]').forEach((price) => {
      if (parseHandle(price.dataset.priceFor) !== handle) return;
      price.textContent = '';
      price.hidden = true;
      delete price.dataset.variantId;
      recordUnavailable(price, handle, error);
    });
    document.querySelectorAll('.view-product-link, .product-image-link').forEach((link) => {
      if (parseHandle(link.getAttribute('href')) !== handle) return;
      if (link.classList.contains('product-image-link')) link.replaceWith(...link.childNodes);
      else link.remove();
    });
  }

  function escHtml(str) {
    return String(str ?? "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[m]));
  }

  function parseHandle(input) {
    try {
      if (!input) return "";
      if (input.includes("/products/")) {
        return new URL(input, window.location.origin)
          .pathname.split("/products/")[1].split("/")[0];
      }
      return input.trim();
    } catch {
      return String(input || "").trim();
    }
  }

  async function fetchProduct(handle) {
    handle = parseHandle(handle);
    if (!handle) throw new Error("Missing handle");
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = (async () => {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin", signal: AbortSignal.timeout(12000) });
      if (!res.ok) {
        const error = new Error('Product request failed');
        error.status = res.status;
        throw error;
      }
      const json = await res.json();
      if (!json?.id || !json.title || !Array.isArray(json.variants)) throw new Error('Invalid product response');
      return json;
    })();
    return productCache[handle];
  }

  function getFirstAvailableVariant(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    return variants.find(v => v.available) || variants[0];
  }

  function getVariantById(product, variantId) {
    if (!product?.variants?.length || !variantId) return null;
    const idStr = String(variantId);
    return product.variants.find(v => String(v.id) === idStr) || null;
  }

  function formatMoney(cents) {
    // Prefer theme money formatting if available
    if (window.Shopify?.formatMoney) {
      const fmt = window.Shopify.money_format || "{{amount_with_currency}}";
      return window.Shopify.formatMoney(Number(cents) || 0, fmt);
    }

    const currency = window.Shopify?.currency?.active || "EUR";
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency })
        .format((Number(cents) || 0) / 100);
    } catch {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function markSoldOut(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add("atc-mini--soldout");
    btn.textContent = soldOutText;
  }

function renderCard(el, product) {
  const img = product.featured_image;
  const productUrl = product.url || `/products/${product.handle}`;
  const title = escHtml(product.title);
  const variant = getFirstAvailableVariant(product.variants);
  const soldOut = variant && !variant.available;
  el.dataset.articleReferenceState = variant ? (soldOut ? 'sold-out' : 'available') : 'unavailable';

  const isNA =
    Array.isArray(product.tags) &&
    product.tags.some(t => String(t).trim().toLowerCase() === "n/a");

  el.innerHTML = `
    <div class="blog-product-mini blog-product-mini--compact ${isNA ? "blog-product-mini--na" : ""}">
      
      ${
        isNA
          ? `
            ${img ? `<img src="${escHtml(img)}" alt="${title}" loading="lazy">` : ``}
          `
          : `
            ${img ? `<a href="${escHtml(productUrl)}" class="product-image-link" aria-label="${title}"><img src="${escHtml(img)}" alt="${title}" loading="lazy"></a>` : ``}
          `
      }

      <div class="product-block product-block--row">
        ${
          isNA
            ? `<span class="product-price tr-price">N/A</span>`
            : (variant?.price != null ? `<span class="product-price tr-price" data-price-for="${escHtml(product.handle)}"></span>` : ``)
        }

        ${
          isNA
            ? ``
            : `<a class="view-product-link" href="${escHtml(productUrl)}">${escHtml(soldOut ? viewSoldOutText : viewText)}</a>`
        }
      </div>
    </div>
  `;
}


  function renderError(el, handle, error) {
    recordUnavailable(el, handle, error);
    el.innerHTML = `<div class="blog-mini-card__unavailable"><p>${escHtml(unavailableMessage(error))}</p>${relatedCollectionLink()}</div>`;
    disableUnavailableControls(handle, error);
  }

  async function fillPricesForCard(cardRoot, product) {
    // cardRoot = .js-blog-mini-card OR any container that holds the span/button
    const priceEl = cardRoot.querySelector(".tr-price[data-price-for]");
    if (!priceEl) return;

    // Prefer the variant id used by the button (so price and ATC match)
    const btn = cardRoot.querySelector(".atc-mini[data-variant-id]");
    const variantId =
      btn?.dataset?.variantId ||
      priceEl.dataset.variantId ||
      null;

    const variant =
      getVariantById(product, variantId) ||
      getFirstAvailableVariant(product.variants);

    if (variant?.price != null) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.dataset.variantId = String(variant.id);
    } else {
      priceEl.textContent = "";
    }
  }

  async function initMiniCards() {
    const nodes = document.querySelectorAll(".js-blog-mini-card[data-handle]");
    if (!nodes.length) return;

    const queue = Array.from(nodes);
    const concurrency = 6;

    async function worker() {
      while (queue.length) {
        const el = queue.shift();
        const handle = el?.dataset?.handle;
        if (!handle) {
          renderError(el, '', {status:404});
          continue;
        }

        try {
          const product = await fetchProduct(handle);
          renderCard(el, product);
          await fillPricesForCard(el, product);
        } catch (error) {
          renderError(el, handle, error);
        }
      }
    }

    const workers = Array.from({ length: Math.min(concurrency, queue.length) }, worker);
    await Promise.all(workers);
  }

  async function initAvailabilityForExistingButtons() {
    // Handles any buttons already in your article HTML (not only generated cards)
    const buttons = document.querySelectorAll(".atc-mini[data-product]");
    if (!buttons.length) return;

    const seen = Object.create(null);

    for (const btn of buttons) {
      const handle = parseHandle(btn.dataset.product);
      if (!handle || seen[handle]) continue;
      seen[handle] = true;

      try {
        const product = await fetchProduct(handle);
        const variant = getFirstAvailableVariant(product.variants);

        document.querySelectorAll(".atc-mini[data-product]").forEach(b => {
          if (parseHandle(b.dataset.product) !== handle) return;
          if (!variant || !variant.available) {
            markSoldOut(b);
          } else {
            b.dataset.variantId = variant.id;
          }
        });

        // Also fill any price spans pointing at this handle
        document.querySelectorAll(`.tr-price[data-price-for="${CSS.escape(handle)}"]`).forEach(el => {
          const root = el.closest(".js-blog-mini-card") || el.closest(".blog-product-mini") || document;
          fillPricesForCard(root === document ? document : root, product);
        });
      } catch (error) {
        disableUnavailableControls(handle, error);
      }
    }
  }

  async function addToCartNative(variantId, qty, properties) {
    const cartNotification = document.querySelector("cart-notification");

    const config = typeof fetchConfig === "function"
      ? fetchConfig("javascript")
      : { headers: {} };

    config.headers = config.headers || {};
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const fd = new FormData();
    fd.append("id", variantId);
    fd.append("quantity", qty);

    if (properties && typeof properties === "object") {
      Object.keys(properties).forEach((key) => {
        const val = properties[key];
        if (val === undefined || val === null || val === "") return;
        fd.append(`properties[${key}]`, String(val));
      });
    }

    if (cartNotification?.getSectionsToRender) {
      fd.append("sections", cartNotification.getSectionsToRender().map(s => s.id));
      fd.append("sections_url", window.location.pathname);
      cartNotification.setActiveElement?.(document.activeElement);
    }

    config.method = "POST";
    config.body = fd;
    config.credentials = "same-origin";

    const url = window.routes?.cart_add_url || "/cart/add";
    const resp = await fetch(url, config);
    const data = await resp.json();

    if (data.status) return { ok: false, data };
    cartNotification?.renderContents?.(data);
    return { ok: true, data };
  }

  // One click handler for all mini ATC buttons
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".atc-mini");
    if (!btn || btn.disabled) return;

    e.preventDefault();

    const handle = parseHandle(btn.dataset.product);
    const qty = btn.dataset.qty || 1;

    try {
      let variantId = btn.dataset.variantId;

      if (!variantId) {
        const product = await fetchProduct(handle);
        const variant = getFirstAvailableVariant(product.variants);
        if (!variant || !variant.available) {
          markSoldOut(btn);
          return;
        }
        variantId = variant.id;
        btn.dataset.variantId = variantId;
      }

      const isSOD = btn.dataset.sod === "1";
      const props = isSOD ? { "Fulfillment": "Ships within 7 business days" } : null;

      const result = await addToCartNative(variantId, qty, props);

      if (!result.ok) {
        const msg = (result.data.description || "").toLowerCase();
        if (result.data.status === 422 || msg.includes("sold") || msg.includes("stock")) {
          markSoldOut(btn);
        }
      }
    } catch (error) {
      disableUnavailableControls(handle, error);
    }
  });

  async function fillAllPrices() {
  const priceEls = document.querySelectorAll(".tr-price[data-price-for]");
  if (!priceEls.length) return;

  // group by handle so we fetch each product once
  const groups = new Map();

  priceEls.forEach((el) => {
    const handle = parseHandle(el.dataset.priceFor);
    if (!handle) return;
    if (!groups.has(handle)) groups.set(handle, []);
    groups.get(handle).push(el);
  });

  for (const [handle, els] of groups.entries()) {
    try {
      const product = await fetchProduct(handle);

      els.forEach((el) => {
        // Prefer a nearby button's variant-id if you ever add it later
        const container = el.closest(".manga-top-picks-item, .blog-product-mini, .js-blog-mini-card") || el.parentElement || document;

        const btn = container.querySelector?.(".atc-mini[data-variant-id]");
        const variantId = btn?.dataset?.variantId || el.dataset.variantId || null;

        const variant =
          getVariantById(product, variantId) ||
          getFirstAvailableVariant(product.variants);

        if (variant?.price != null) {
          el.textContent = formatMoney(variant.price);
          el.dataset.variantId = String(variant.id);
        } else {
          el.textContent = "";
        }
      });
    } catch (error) {
      disableUnavailableControls(handle, error);
    }
  }
}


async function init() {
  await initMiniCards();                   // renders cards + fills their price
  await initAvailabilityForExistingButtons();
  await fillAllPrices();                   // ✅ fills booster box .tr-price blocks too
}


  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
